<template>
    <div class="flex flex-col">
      <h1 class="sr-only">SkyLantern - Guirlandes Guinguettes Pro, Guirlandes Lumineuses & Lanternes Volantes</h1>
      <main-slider :slider="newHomepageSlides" />
      <old-main-categories
        class="md:mb-16 order-first md:order-none md:hidden"
        :categories="newHomepageCategories"
      />
      <main-categories
        class="md:mb-16 order-first md:order-none hidden md:block"
        :categories="newHomepageCategories"
      />
      <product-showcase
        :showcase="firstShowcase.products"
      />
      <inspiration :inspiration="newHomepageInspiration" class="mb-8 md:mb-36" />
      <client-searches
        :searches="newCustomerSearches"
        class="mb-3"
      />
      <bio
        style="margin-bottom: -60px;"
      />
      <newsletter-registration
        class="mb-10"
      />
    </div>
  </template>
  
  <script>
  import MainSlider from '../components/homepage-v2/MainSlider'
  import MainCategories from '../components/homepage-v2/MainCategories'
  import OldMainCategories from '../components/homepage/MainCategories'
  import ProductShowcase from '../components/homepage-v2/ProductShowcase'
  import Inspiration from '../components/homepage-v2/Inspiration'
  import ClientSearches from '../components/homepage-v2/ClientSearches'
  import InstagramFeed from '../components/homepage-v2/InstagramFeed'
  import Bio from '../components/homepage-v2/Bio'
  import NewsletterRegistration from '../components/homepage-v2/NewsletterRegistration'
  
  export default {
    components: {
      MainSlider,
      MainCategories,
      ProductShowcase,
      Inspiration,
      ClientSearches,
      InstagramFeed,
      Bio,
      NewsletterRegistration,
      OldMainCategories
    },
    async asyncData ({ app }) {
      const { data } = await app.$api.get('/home')
      return data
    },
    head () {
      const title = 'N°1 Décoration de mariage - Lanterne Volante - SkyLantern.fr'
      const description = 'Le + grand choix de décoration de mariage : lanternes volantes, guirlandes lumineuses, Bougie LED, lampions et boules japonaises. Livraison 24H'
      const links = [
        {
          rel: 'canonical',
          href: this.$host
        }
      ]
      // Preload LCP (first slide: video poster or image)
      const firstSlide = this.newHomepageSlides?.[0]
      if (firstSlide?.attributes?.video_url) {
        const posterUrl = firstSlide.attributes.video_poster || (firstSlide.attributes.big_picture ? `${firstSlide.attributes.big_picture}?resize=true&width=1500&format=webp` : null)
        if (posterUrl) {
          links.push({ rel: 'preload', as: 'image', href: posterUrl })
        }
        links.push({ rel: 'preconnect', href: 'https://player.vimeo.com' })
        links.push({ rel: 'preconnect', href: 'https://i.vimeocdn.com' })
        links.push({ rel: 'preconnect', href: 'https://f.vimeocdn.com' })
        links.push({ rel: 'preconnect', href: 'https://vod-progressive.akamaized.net' })
        links.push({ rel: 'dns-prefetch', href: 'https://player.vimeo.com' })
        links.push({ rel: 'dns-prefetch', href: 'https://f.vimeocdn.com' })
        links.push({ rel: 'dns-prefetch', href: 'https://vod-progressive.akamaized.net' })
      } else if (firstSlide?.attributes?.big_picture) {
        links.push({
          rel: 'preload',
          as: 'image',
          href: `${firstSlide.attributes.big_picture}?resize=true&width=1500&format=webp`
        })
      }
      return {
        title,
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: description
          },
          { hid: 'og:title', property: 'og:title', content: title },
          { hid: 'og:description', property: 'og:description', content: description },
          { hid: 'og:url', property: 'og:url', content: this.$host },
          { hid: 'og:type', property: 'og:type', content: 'website' },
          { hid: 'og:site_name', property: 'og:site_name', content: 'SkyLantern' }
        ],
        link: links
      }
    },
    mounted () {
      this.$gtmEvents.onRegularPageView()
    }
  }
  </script>
  